import React from 'react';
import { Flex, Box, Text, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Tooltips from './Tooltips';
import { ENV } from '../../constants';

interface Props {
  data: any;
  phoneWidth: number;
}

const HighlightFilter: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Box
      _hover={{ bg: 'gray.200' }}
      backgroundColor="gray.100"
      transition="150ms ease"
      position="relative"
      p={1}
      margin="5px 0 5px 0"
    >
      <>
        <Flex align="center">
          <Text fontWeight="bold" fontSize="lg" mr={2}>
            {data?.name}
          </Text>
          <Tooltips data={data} />
        </Flex>
        {!!data?.description && (
          <Text fontSize="xs" color="gray.400">
            {data.description}
          </Text>
        )}
      </>
      <Flex justify="center" direction="row" p={4}>
        {data.items ? (
          // eslint-disable-next-line array-callback-return, consistent-return
          data.items.map((item: any) => {
            return (
              <Flex
                justifyContent="center"
                alignItems="center"
                style={{
                  marginBottom: 3,
                  marginRight: 0,
                  marginLeft: 0,
                }}
              >
                {data?.type !== 'text' && (
                  <Image
                    w="50px"
                    h="50px"
                    marginLeft={3}
                    marginRight={3}
                    borderRadius="5px"
                    src={
                      item?.file?.id
                        ? `${ENV.REACT_APP_CMS_HOST}/file/${encodeURI(
                            item?.file?.name,
                          )}`
                        : undefined
                    }
                  />
                )}
                {data?.type === 'text' && (
                  <Text
                    key={item.id}
                    ml={1}
                    style={{
                      padding: 10,
                      backgroundColor: '#fff',
                      borderRadius: 50,
                    }}
                  >
                    {item.name}
                  </Text>
                )}
              </Flex>
            );
          })
        ) : (
          <Text>{t('noAddedItems')}</Text>
        )}
      </Flex>
    </Box>
  );
};

export default HighlightFilter;
